import { useState, useEffect } from "react";
const DEFAULT_OPTIONS = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: 1.0
};

export default function useIntersectionObserver(target, cb, options = DEFAULT_OPTIONS) {

    const [observer, setObserver] = useState(null);

    useEffect(() => {
        const obs = new IntersectionObserver(cb, options);
        setObserver(obs);
    }, []);

    useEffect(() => {
        if (!observer) return;
        observer.observe(target);
        return () => {
            if (observer) observer.disconnect();
        };
    }, [target, observer])

}